import axios from "axios";
import { config } from "../../api-helper/api-header-configs";
const baseURL = process.env.REACT_APP_API_URL;

// Create Category
export const add_project_category = async (values: any) => {
    const payload = {
        category_name: values.category_name,
        description: values.description || '',
        status: values.status || '1'
    };
    const response = await axios.post(baseURL + "/categories", payload, config);
    return response.data;
}

// List Categories of a Project (kept for backward compatibility, but may not be needed)
export const get_categories_of_project = async (projectId: string) => {
    const response = await axios.get(baseURL + `/categoriesofproject/${projectId}`, {
        params: { 
            _t: Date.now() // Cache busting - ensures fresh data on each request
        }
    });
    return response.data;
}

// List All Categories
export const get_all_categories = async () => {
    const response = await axios.get(baseURL + "/categories", {
        params: {
            _t: Date.now() // Cache busting
        }
    });
    return response.data;
}

// Update Category
export const update_project_category = async (id: string, values: any) => {
    const payload = {
        category_name: values.category_name,
        description: values.description || '',
        status: values.status || '1'
    };
    const response = await axios.patch(baseURL + `/categories/${id}`, payload, config);
    return response.data;
}

// Delete Category
export const delete_project_category = async (id: string) => {
    const response = await axios.delete(baseURL + `/categories/${id}`, config);
    return response.data;
}

// Get All Project Categories Logs
export const get_all_projectcategories_logs = async (projectId: number) => {
    let response = await axios.get(baseURL + `/all-projectcategories-logs/${projectId}`);
    return response.data;
}

// Get Single Project Category Log
export const get_single_projectcategory_log = async (categoryId: number) => {
    let response = await axios.get(baseURL + `/single-projectcategory-log/${categoryId}`);
    return response.data;
}


